import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-processBar",
  "use": "icon-processBar-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\" class=\"lds-progress-pie\" id=\"icon-processBar\">\n    <path fill=\"none\" ng-attr-d=\"{{config.d}}\" ng-attr-stroke=\"{{config.c1}}\" ng-attr-stroke-width=\"{{config.w}}\" d=\"M50 35A15 15 0 0 1 50 65A15 15 0 0 1 50 35\" stroke=\"#e15b64\" stroke-width=\"30\">\n      <animate attributeName=\"stroke-dasharray\" calcMode=\"spline\" values=\"0 0 0 95;0 0 95 95;0 95 95 95\" keyTimes=\"0;0.5;1\" dur=\"0.75\" keySplines=\"0.5 0 0.5 1;0.5 0 0.5 1\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\n      <animate attributeName=\"stroke\" ng-attr-values=\"{{config.colors}}\" keyTimes=\"0;0.25;0.5;0.75;1\" ng-attr-dur=\"{{config.speed2}}s\" calcMode=\"discrete\" repeatCount=\"indefinite\" values=\"#e15b64;#f8b26a;#9fcaa5;#818dbd;#e15b64\" dur=\"3s\"></animate>\n    </path>\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/processBar.svg
// module id = aD0r
// module chunks = 148